import { IIconProps } from "../types"

export default function IconLR2(props: IIconProps) {
  const width = props.size || props.width || (88 / 5) * 3
  const height = props.size || props.height || (117 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 88 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.540895 10.5998C0.880786 7.61077 2.12039 6.03128 5.04945 4.7117C7.96851 3.39213 12.587 2.34246 21.4142 1.5927C30.2414 0.842943 43.2972 0.403084 52.8041 0.453068C62.3111 0.493055 68.2692 1.02289 72.7677 2.07255C77.2663 3.13221 80.3053 4.7117 82.3847 7.48082C84.464 10.2499 85.5936 14.1987 86.3234 19.9968C87.0532 25.8049 87.3931 33.4425 86.7133 47.548C86.0435 61.6535 84.354 82.2169 82.2147 94.293C80.0754 106.379 77.4962 109.978 73.7774 112.307C70.0686 114.636 65.2302 115.696 59.552 116.136C53.8738 116.566 47.3459 116.396 42.2875 115.296C37.2191 114.197 33.6203 112.177 30.5313 109.278C27.4323 106.379 24.8431 102.6 21.2443 93.7232C17.6454 84.846 13.0269 70.8805 9.54801 58.1346C6.05913 45.3987 3.68989 33.8824 2.23035 25.9349C0.770822 17.9774 0.211001 13.5889 0.540895 10.5998Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
